
interface Props {
    id?:string,
    className?:string,
    title?:string,
    subtitle?:string,
    children?: React.ReactNode;
    style?:any,
    onClick?:any
}    

const Box = (props: Props) => {

  const className = props.className ? " "+props.className : "";
  const id = props.id ? props.id : "";

  const style = props.style ? props.style : {};


  const box_header = props.title? <div className='box_header'>
    <h2 className='card_title'>{props.title}</h2>
    <span className='card_subtitle'>{props.subtitle}</span>
  </div> : null;
  
  

  return (
    
    <div id={id} className={"box"+className} style={style} onClick={props.onClick}>
      <div className="box_children">

        {box_header}

        <div className="box_content">
          {props.children}
        </div>

      </div>
    </div>
  );
};



export default Box;